export default function Navbar() {
  return (
    <nav className="tealPrimary padding-left20">
      <div className="nav-wrapper">
        <a href="suacode.ai" className="brand-logo">SuaCode.ai</a>
      </div>
    </nav>);
}